import { render, staticRenderFns } from "./register-step-3-credentials.component.vue?vue&type=template&id=e86282fe&"
import script from "./register-step-3-credentials.component.vue?vue&type=script&lang=ts&"
export * from "./register-step-3-credentials.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports